module.exports = __webpack_public_path__ + "static/media/icon-ig-red.2951c6f3.svg";